module.exports = __webpack_public_path__ + "static/img/5ab58ce7dd79b1f1(1).08ce7c8c.png";